import InfoCollaborator from '@/directory/infoCollaborator';
import { getUserWithProfile, type CombinedUser } from '@/lib/collections/workerProfile-Users/getUserWithProfile';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/directory/$id/')({
  beforeLoad: ({ context }) => {
    if (!context.user) throw redirect({ to: '/login' });
    // // Solo RRHH y Admin pueden acceder
    // if (!context.userRoles.isRRHH && !context.userRoles.isAdmin) {
    //   throw redirect({ to: '/unauthorized' });
    // }
  },
  loader: async ({ params }) => {
    const user = await getUserWithProfile(params.id);
    if (!user) throw new Error("Usuario no encontrado");
    return user;
  },
  component: UserDetail,
});

function UserDetail() {
  const user = Route.useLoaderData() as CombinedUser;
  return (<InfoCollaborator user={user} />
  )
}
